<template>
  <div class="d-flex  justify-center">
    <v-icon color="black" style="font-size:52px; margin-right: 5px;"
    @click="goBack"
    >arrow_back</v-icon>
    <span style="font-size:45px;font-weight:bold;color:black;-webkit-text-stroke: 2px black;">
    {{ titleName }}
    </span>
  </div>
</template>
<script>
  export default {
    methods: {
      goBack () {
        this.$router.back()
      }
    },
    props: {
      titleName: {
        type: String,
        default () {
          return ''
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/autoservicios/autoservicio-btn-back.vue